var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
var SplitButtonItem = /** @class */ (function (_super) {
    __extends(SplitButtonItem, _super);
    function SplitButtonItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    SplitButtonItem.prototype.render = function () {
        return null;
    };
    /**
     * @hidden
     */
    SplitButtonItem.propTypes = {
        text: PropTypes.string,
        icon: PropTypes.string,
        iconClass: PropTypes.string,
        imageUrl: PropTypes.string,
        disabled: PropTypes.bool,
        render: PropTypes.any
    };
    return SplitButtonItem;
}(React.Component));
export default SplitButtonItem;
//# sourceMappingURL=SplitButtonItem.js.map